// import {
//   Button,
//   Modal,
//   Input,
//   Card,
//   DatePicker,
//   Row,
//   Col,
//   message,
//   Radio,
//   Tag,
//   Space,
//   Table,
//   InputNumber,
//   Divider,
//   Tooltip,
//   Progress,
//   Avatar,
// } from "antd";
// import React, { useEffect, useState } from "react";
// import ListeChauffeur from "../../../composants/ListeChauffeur";
// import ListeEnergie from "../../../composants/ListeEnergie";
// import ListeAppartenance from "../../../composants/ListeAppartenance";
// import ListeType from "../../../composants/ListeType";
// import ListeSite from "../../../composants/ListeSite";
// import moment from "moment";
// import "moment/locale/fr";
// import {
//   addCallibrage,
//   createCamion,
//   disableCamion,
//   exportCamion,
//   get_listeCamion,
//   updateCamion,
// } from "../../../api/camion";
// import { get_ListeSite } from "../../../api/site";
// import {
//   EnvironmentOutlined,
//   WarningOutlined,
//   DashboardOutlined,
//   AreaChartOutlined,
//   ApiOutlined,
//   EditFilled,
//   BgColorsOutlined,
//   AppstoreOutlined,
//   TableOutlined,
//   DeleteOutlined,
//   ExportOutlined,
//   ShrinkOutlined,
//   PlusOutlined,
//   UserOutlined,
//   ThunderboltOutlined,
//   ExclamationCircleFilled,
//   CheckCircleFilled,
//   SearchOutlined,
//   ReloadOutlined,
//   LineChartOutlined,
// } from "@ant-design/icons";

// import { get_ListeChauffeur } from "../../../api/chauffeur";
// import * as config from "../../../config/config";
// import { get_ListeStatut } from "../../../api/statut";
// import ListeStatut from "../../../composants/ListeStatut";
// import formatDateFr, { getPermissionsFromToken, hasPermission } from "../../../utils/utils";
// import Notification from "../../../composants/Notification";
// // NOTE : adapte ce chemin selon l'emplacement réel de ConsommationCarburant.jsx
// // (ici on suppose src/pages/dashboard/ConsommationCarburant.jsx)
// import ConsommationCarburant from "./ConsommationCarburant";

// const { RangePicker } = DatePicker;

// // ---- Palette & helpers de statut / alertes -------------------------------

// const STATUT_COLORS = {
//   1: "#2563eb", // en service
//   2: "#ef4444", // hors service
//   3: "#16a34a", // disponible
//   4: "#f59e0b", // maintenance
// };
// const getStatutColor = (id) => STATUT_COLORS[id] || "#94a3b8";

// const APPARTENANCE_COLORS = {
//   1: "#16a34a", // propre
//   2: "#d97706", // location
// };

// // Renvoie une alerte { level: 'expired' | 'warning', label } ou null
// const getDateAlerte = (dateStr, seuilJours = 30) => {
//   if (!dateStr) return null;
//   const diff = moment(dateStr).startOf("day").diff(moment().startOf("day"), "days");
//   if (diff < 0) return { level: "expired", label: "Expiré" };
//   if (diff <= seuilJours) return { level: "warning", label: `${diff} j restants` };
//   return null;
// };

// // Regroupe toutes les alertes pertinentes d'un camion (docs + vidange)
// const getAlertesCamion = (item) => {
//   const alertes = [];
//   const assurance = getDateAlerte(item.date_assurance);
//   if (assurance) alertes.push({ ...assurance, type: "Assurance" });

//   const visite = getDateAlerte(item.date_visite_technique);
//   if (visite) alertes.push({ ...visite, type: "Visite technique" });

//   if (item.dernier_km_vidange && item.intervalle_km_vidange) {
//     const kmRestant =
//       item.dernier_km_vidange + item.intervalle_km_vidange - (item.kilometrage || 0);
//     if (kmRestant <= 0) {
//       alertes.push({ level: "expired", label: "Dépassée", type: "Vidange" });
//     } else if (kmRestant <= 500) {
//       alertes.push({ level: "warning", label: `Dans ${kmRestant} km`, type: "Vidange" });
//     }
//   }
//   return alertes;
// };

// const getCarburantPercent = (item) => {
//   if (!item.fond_cuve || item.fond_cuve === 0) return 0;
//   return Math.min(100, Math.round(((item.carburant || 0) / item.fond_cuve) * 100));
// };

// const getCarburantColor = (pct) => (pct < 20 ? "#ef4444" : pct < 50 ? "#f59e0b" : "#16a34a");

// const getInitiales = (nom, prenom) =>
//   `${nom?.[0] || ""}${prenom?.[0] || ""}`.toUpperCase() || "?";

// const Camion = ({ liste_camion }) => {
//   const permissions = getPermissionsFromToken();
//   const [isCardView, setIsCardView] = useState(true);
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [isModalDisableOpen, setisModalDisableOpen] = useState(false);
//   const [listeCamion, setlisteCamion] = useState([]);
//   const [chauffeurListe, setchauffeurListe] = useState([]);
//   const [listeStatutCamion, setlisteStatutCamion] = useState([]);
//   const [selectedCamion, setselectedCamion] = useState({
//     id: null,
//     imm: "",
//     imm_rem: "",
//     reference: "",
//     marque: "",
//     fond_cuve: 0,
//     carburant: 0,
//     lim_vt: null,
//     lim_ass: null,
//     energie_id: 0,
//     chauffeur_id: 0,
//     type_id: 0,
//     appartenance_id: 0,
//     site_id: 0,
//     kilometrage: 0,
//     images: null,
//     dernier_date_vidange: null,
//     intervalle_km_vidange: null,
//     dernier_km_vidange: 0,
//     num_carte_grise: null,
//     num_patente: null
//   });
//   const [search, setSearch] = useState("");
//   const [searchStatut, setsearchStatut] = useState(null);
//   const [listeSite, setlisteSite] = useState([]);
//   const [titleModal, settitleModal] = useState("Ajouter un camion");
//   const [isUpdate, setisUpdate] = useState(false);
//   const [isExportModal, setisExportModal] = useState(false);
//   const [filteredCamions, setfilteredCamions] = useState([]);
//   const [isLoading, setisLoading] = useState(false);
//   const [exportdata, setexportdata] = useState({
//     dates: null,
//     type: null,
//   });
//   const [showToast, setshowToast] = useState(false);
//   const [notif, setnotif] = useState({
//     message: null,
//     info: null,
//   });
//   const [showModalCallibrage, setshowModalCallibrage] = useState(false);
//   const [isConsommationModalOpen, setisConsommationModalOpen] = useState(false);
//   const [currentCallibrage, setcurrentCallibrage] = useState([
//     {
//       x: 0,
//       y: 0,
//     },
//   ]);
//   useEffect(() => {
//     fetchListeCamion();
//     fetchListeChauffeur();
//     fetchListeSite();
//     fetchListeStatut();
//   }, []);

//   const showModal = () => {
//     setIsModalOpen(true);
//   };

//   const handleOk = async () => {
//     try {
//       setisLoading(true);
//       const isUpdateMode = Boolean(isUpdate);
//       const payload = {
//         ...selectedCamion,
//         lim_vt: selectedCamion.lim_vt
//           ? moment(selectedCamion.lim_vt).format("YYYY-MM-DD HH:mm:ss")
//           : null,
//         lim_ass: selectedCamion.lim_ass
//           ? moment(selectedCamion.lim_ass).format("YYYY-MM-DD HH:mm:ss")
//           : null,
//       };

//       const action = isUpdateMode ? updateCamion : createCamion;
//       const successMsg = isUpdateMode
//         ? "Camion mis à jour avec succès 🚚"
//         : "Camion créé avec succès 🚛";
//       const errorMsg = isUpdateMode
//         ? "Erreur lors de la mise à jour du camion ❌"
//         : "Erreur lors de la création du camion ❌";

//       const res = await action(payload);

//       if (res?.status === "success") {
//         message.success(successMsg, 2);
//         setnotif({
//           ...notif,
//           message: successMsg,
//           info: "success",
//         });
//         setshowToast(true);
//         setTimeout(() => window.location.reload(), 2000);
//       } else {
//         message.error(errorMsg, 2);
//         setnotif({
//           ...notif,
//           message: errorMsg,
//           info: "error",
//         });
//         setshowToast(true);
//         setTimeout(() => window.location.reload(), 2000);
//       }
//     } catch (err) {
//       console.error("Erreur handleOk:", err);
//       message.error("Une erreur inattendue est survenue ❗", 2);
//     }
//   };

//   const handleCancel = () => {
//     setIsModalOpen(false);
//     settitleModal("Ajouter un camion");
//     setisUpdate(false);
//     setselectedCamion({
//       id: null,
//       imm: "",
//       imm_rem: "",
//       reference: "",
//       marque: "",
//       fond_cuve: 0,
//       carburant: 0,
//       lim_vt: null,
//       lim_ass: null,
//       energie_id: 0,
//       chauffeur_id: 0,
//       type_id: 0,
//       appartenance_id: 0,
//       site_id: 0,
//       kilometrage: 0,
//       images: null,
//       dernier_date_vidange: null,
//       intervalle_km_vidange: null,
//       dernier_km_vidange: 0,
//       num_carte_grise: null,
//       num_patente: null
//     });
//   };

//   const handleChangeForm = (e) => {
//     const value = e.target.value;
//     setselectedCamion({
//       ...selectedCamion,
//       [e.target.name]: value,
//     });
//   };

//   const fetchListeCamion = async () => {
//     const res = await get_listeCamion();
//     if (res.status === "success") {
//       setlisteCamion(res.data);
//       setfilteredCamions(res.data);
//     }
//   };

//   const fetchListeSite = async () => {
//     const res = await get_ListeSite();
//     if (res.status === "success") {
//       setlisteSite(res.data);
//     }
//   };

//   const fetchListeStatut = async () => {
//     const res = await get_ListeStatut();
//     if (res.status === "success") {
//       setlisteStatutCamion(res.data);
//     }
//   };

//   const fetchListeChauffeur = async () => {
//     const res = await get_ListeChauffeur();
//     if (res.status === "success") {
//       setchauffeurListe(res.data);
//     }
//   };

//   const handleSearchTexteCamion = (e) => {
//     let text = e.target.value;
//     setSearch(text);
//     console.log(text.length);
//     if (text.length === 0) {
//       setfilteredCamions(listeCamion);
//       setsearchStatut(0);
//     } else {
//       let mon_filtre = filteredCamions.filter(
//         (camion) =>
//           camion.imm.toLowerCase().includes(search.toLowerCase()) ||
//           camion.marque.toLowerCase().includes(search.toLowerCase())
//       );
//       setfilteredCamions(mon_filtre);
//     }
//   };

//   const handleSearchStatutCamion = (value) => {
//     setSearch(0);
//     setfilteredCamions(listeCamion);
//     if (value === null || value === 0) {
//       setfilteredCamions(listeCamion);
//     } else {
//       let mon_filtre = listeCamion.filter(
//         (camion) => camion.statut_id === value
//       );
//       console.log(mon_filtre);
//       setfilteredCamions(mon_filtre);
//     }
//   };

//   const handleReload = () => {
//     setisLoading(true);
//     setTimeout(() => {
//       window.location.reload();
//     }, 2);
//   };

//   const handleEditCamion = (item) => {
//     settitleModal("Mettre à jour un camion");
//     setisUpdate(true);
//     setselectedCamion({
//       ...selectedCamion,
//       id: item.id,
//       imm: item.imm,
//       imm_rem: item.imm_remorque,
//       reference: item.reference,
//       marque: item.marque,
//       fond_cuve: item.fond_cuve,
//       carburant: item.carburant,
//       lim_vt: item.date_visite_technique
//         ? moment(item.date_visite_technique)
//         : null,
//       lim_ass: item.date_assurance ? moment(item.date_assurance) : null,
//       energie_id: item.energie_id,
//       chauffeur_id: item.chauffeur_id,
//       type_id: item.type_id,
//       appartenance_id: item.appartenance_id,
//       site_id: item.site_id,
//       kilometrage: item.kilometrage,
//       images: null,
//       dernier_date_vidange: item.dernier_date_vidange
//         ? moment(item.dernier_date_vidange)
//         : null,
//       intervalle_km_vidange: item.intervalle_km_vidange,
//       dernier_km_vidange: item.dernier_km_vidange,
//       num_carte_grise: item.num_carte_grise,
//       num_patente: item.num_patente
//     });
//     showModal(true);
//   };

//   // gestion fichier
//   const handleFileChange = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       const reader = new FileReader();
//       reader.onloadend = () => {
//         setselectedCamion((prev) => ({
//           ...prev,
//           images: reader.result, // base64
//         }));
//       };
//       reader.readAsDataURL(file);
//     }
//   };

//   const handleDelete = (item) => {
//     setselectedCamion(item);
//     setisModalDisableOpen(true);
//   };

//   const handleOkDisable = async () => {
//     setisLoading(true);
//     const res = await disableCamion(selectedCamion.id);
//     if (res.status === "success") {
//       message.success("Camion supprimé avec success !!!", 2);
//     } else {
//       message.warning("Camion non supprimé !!!", 2);
//     }
//     setTimeout(() => {
//       window.location.reload();
//     }, 1500);
//   };

//   const handleExport = async () => {
//     setisLoading(true);
//     await exportCamion(selectedCamion.id, exportdata);
//     setisLoading(false);
//   };

//   // ---- Colonnes du tableau : infos essentielles visibles sans "Éditer" ----
//   const columns = [
//     {
//       title: "Véhicule",
//       dataIndex: "imm",
//       key: "imm",
//       fixed: "left",
//       width: 170,
//       render: (imm, record) => (
//         <div>
//           <div style={{ fontWeight: 600, fontSize: 13.5, color: "#1f2937" }}>{imm}</div>
//           <div style={{ fontSize: 12, color: "#9ca3af" }}>{record.marque}</div>
//         </div>
//       ),
//     },
//     {
//       title: "Chauffeur",
//       dataIndex: "chauffeur_id",
//       key: "chauffeur_id",
//       render: (id) => {
//         const ch = chauffeurListe.find((c) => c.id === id);
//         if (!ch) return <span style={{ color: "#c1c7d0", fontSize: 13 }}>Non assigné</span>;
//         return (
//           <Space size={8}>
//             {/* <Avatar size={26} style={{ background: "#eef2ff", color: "#4f46e5", fontSize: 11, fontWeight: 600 }}>
//               {getInitiales(ch.nom, ch.prenom)}
//             </Avatar> */}
//             <span style={{ fontSize: 13 }}>{ch.nom} {ch.prenom}</span>
//           </Space>
//         );
//       },
//     },
//     {
//       title: "Site",
//       dataIndex: "site_id",
//       key: "site_id",
//       render: (id) => {
//         const site = listeSite.find((s) => s.id === id);
//         return (
//           <Space size={4}>
//             <EnvironmentOutlined style={{ color: "#9ca3af" }} />
//             <span style={{ fontSize: 13 }}>{site ? site.nom : "-"}</span>
//           </Space>
//         );
//       },
//     },
//     {
//       title: "Kilométrage",
//       dataIndex: "kilometrage",
//       key: "kilometrage",
//       sorter: (a, b) => (a.kilometrage || 0) - (b.kilometrage || 0),
//       render: (val) => <span style={{ fontSize: 13 }}>{Number(val || 0).toLocaleString("fr-FR")} km</span>,
//     },
//     {
//       title: "Carburant",
//       key: "carburant",
//       width: 120,
//       render: (_, record) => {
//         const pct = getCarburantPercent(record);
//         const color = getCarburantColor(pct);
//         return (
//           <div style={{ minWidth: 90 }}>
//             <div style={{ display: "flex", justifyContent: "space-between", fontSize: 11.5, color: "#6b7280", marginBottom: 3 }}>
//               <span>{record.carburant} L</span>
//               <span style={{ color, fontWeight: 600 }}>{pct}%</span>
//             </div>
//             <div style={{ height: 5, borderRadius: 4, background: "#f1f2f4", overflow: "hidden" }}>
//               <div style={{ height: "100%", width: `${pct}%`, background: color, borderRadius: 4, transition: "width .3s" }} />
//             </div>
//           </div>
//         );
//       },
//     },
//     {
//       title: "Statut",
//       dataIndex: "statut_id",
//       key: "statut_id",
//       render: (id) => {
//         const stat = listeStatutCamion.find((s) => s.id === id);
//         return (
//           <Tag color={getStatutColor(id)} style={{ borderRadius: 20, border: "none", padding: "1px 10px", fontWeight: 500 }}>
//             {stat ? stat.nom : "-"}
//           </Tag>
//         );
//       },
//     },
//     {
//       title: "Alertes",
//       key: "alertes",
//       width: 150,
//       render: (_, record) => {
//         const alertes = getAlertesCamion(record);
//         if (alertes.length === 0) {
//           return (
//             <Tag icon={<CheckCircleFilled />} color="success" style={{ borderRadius: 20, border: "none" }}>
//               OK
//             </Tag>
//           );
//         }
//         return (
//           <Space direction="vertical" size={3}>
//             {alertes.slice(0, 2).map((a, i) => (
//               <Tooltip key={i} title={`${a.type} — ${a.label}`}>
//                 <Tag
//                   icon={<ExclamationCircleFilled />}
//                   color={a.level === "expired" ? "error" : "warning"}
//                   style={{ borderRadius: 20, border: "none", fontSize: 11 }}
//                 >
//                   {a.type}
//                 </Tag>
//               </Tooltip>
//             ))}
//           </Space>
//         );
//       },
//     },
//     {
//       title: "Actions",
//       key: "actions",
//       fixed: "right",
//       width: 150,
//       render: (_, record) => (
//         <Space size={2}>
//           {hasPermission(getPermissionsFromToken(), "CAMION_EDIT") && (
//             <Tooltip title="Éditer">
//               <Button
//                 type="text"
//                 size="small"
//                 icon={<EditFilled style={{ color: "#faad14" }} />}
//                 onClick={() => handleEditCamion(record)}
//               />
//             </Tooltip>
//           )}
//           {hasPermission(getPermissionsFromToken(), "CAMION_DELETE") && (
//             <Tooltip title="Supprimer">
//               <Button
//                 type="text"
//                 size="small"
//                 danger
//                 icon={<DeleteOutlined />}
//                 onClick={() => handleDelete(record)}
//               />
//             </Tooltip>
//           )}
//           {hasPermission(getPermissionsFromToken(), "CAMION_EXPORT") && (
//             <Tooltip title="Exporter">
//               <Button
//                 type="text"
//                 size="small"
//                 icon={<ExportOutlined style={{ color: "#1677ff" }} />}
//                 onClick={() => {
//                   setselectedCamion(record);
//                   setisExportModal(true);
//                 }}
//               />
//             </Tooltip>
//           )}
//           {hasPermission(getPermissionsFromToken(), "CAMION_CONSOMMATION") && (
//             <Tooltip title="Consommation carburant">
//               <Button
//                 type="text"
//                 size="small"
//                 icon={<LineChartOutlined style={{ color: "#16a34a" }} />}
//                 onClick={() => {
//                   setselectedCamion(record);
//                   setisConsommationModalOpen(true);
//                 }}
//               />
//             </Tooltip>
//           )}
//         </Space>
//       ),
//     },
//   ];

//   const handleAddCalibrage = async () => {
//     setisLoading(true);
//     if (
//       !selectedCamion?.id ||
//       !currentCallibrage ||
//       currentCallibrage.length === 0 ||
//       currentCallibrage.some((item) => item.x === null || item.y === null)
//     ) {
//       setnotif({
//         ...notif,
//         message: "Champs obligatoires manquants !!!",
//         info: "warning",
//       });
//       setshowToast(true);
//       setTimeout(() => setisLoading(false), 1500);
//       return;
//     }

//     try {
//       const promises = currentCallibrage.map((item) =>
//         addCallibrage(selectedCamion.id, item)
//       );

//       const results = await Promise.all(promises);

//       // Vérifier si tout est OK
//       const allSuccess = results.every((r) => r?.status === "success");

//       if (allSuccess) {
//         setnotif({
//           ...notif,
//           message: "Tous les calibrages ont été insérés avec succès ✅",
//           info: "success",
//         });
//         setshowToast(true);
//         setTimeout(() => window.location.reload(), 1500);
//       } else {
//         setnotif({
//           ...notif,
//           message: "Certaines insertions ont échoué ❌",
//           info: "error",
//         });
//         setshowToast(true);
//         setisLoading(false);
//       }
//     } catch (error) {
//       console.error(error);
//       setnotif({
//         ...notif,
//         message: "Erreur lors de l’insertion des calibrages",
//         info: "error",
//       });
//       setshowToast(true);
//       setTimeout(() => setisLoading(false), 1500);
//     }
//   };

//   const handleAddRow = () => {
//     setcurrentCallibrage([...currentCallibrage, { x: 0, y: 0 }]);
//   };

//   const handleRemoveRow = (index) => {
//     const newList = currentCallibrage.filter((_, i) => i !== index);
//     setcurrentCallibrage(newList);
//   };

//   const handleChangeCallibrage = (index, field, value) => {
//     const newList = [...currentCallibrage];
//     newList[index][field] = value;
//     setcurrentCallibrage(newList);
//   };

//   return (
//     <div style={{ overflow: "hidden" }}>
//       {/* Styles locaux : hover cartes + scrollbar + tag sans bordure */}
//       <style>{`
//         .fleet-card {
//           transition: transform .18s ease, box-shadow .18s ease;
//           box-shadow: 0 1px 2px rgba(16,24,40,.05);
//         }
//         .fleet-card:hover {
//           transform: translateY(-3px);
//           box-shadow: 0 12px 24px -8px rgba(16,24,40,.14);
//         }
//         .fleet-toolbar .ant-input-affix-wrapper,
//         .fleet-toolbar .ant-select-selector {
//           border-radius: 10px !important;
//         }
//         .fleet-scroll::-webkit-scrollbar { width: 6px; }
//         .fleet-scroll::-webkit-scrollbar-thumb { background: #e2e5ea; border-radius: 8px; }
//       `}</style>

//       {/* ---- Header ---- */}
//       <Row align="middle" justify="space-between">
//         <Col>
//           <h3 style={{ marginBottom: 2, fontSize: 20 }}>
//             <strong>Gestion des camions</strong>
//           </h3>
//           <p style={{ margin: 0, color: "#8c8c8c" }}>
//             {listeCamion && listeCamion.length > 0
//               ? `${listeCamion.length} ${listeCamion.length > 1 ? "camions" : "camion"} dans votre flotte`
//               : "Aucun camion dans votre flotte"}
//           </p>
//         </Col>
//       </Row>

//       {/* ---- Toolbar ---- */}
//       <Row
//         className="fleet-toolbar"
//         align="middle"
//         gutter={[12, 12]}
//         style={{
//           marginTop: 20,
//           marginBottom: 20,
//           padding: "14px 16px",
//           background: "#fafafa",
//           border: "1px solid #f0f0f0",
//           borderRadius: 14,
//         }}
//       >
//         <Col flex="0 0 180px">
//           <Input
//             prefix={<SearchOutlined style={{ color: "#bbb" }} />}
//             placeholder="Immatriculation, marque..."
//             allowClear
//             onChange={handleSearchTexteCamion}
//             style={{ width: "100%", borderRadius: 10 }}
//           />
//         </Col>
//         <Col flex="0 1 220px">
//           <ListeStatut
//             liste={listeStatutCamion}
//             onchange={(value) => {
//               setsearchStatut(value);
//               handleSearchStatutCamion(value);
//             }}
//             valeur={searchStatut}
//           />
//         </Col>
//         <Col flex="0 0 auto">
//           <Button
//             loading={isLoading}
//             icon={<ReloadOutlined />}
//             onClick={handleReload}
//             style={{ borderRadius: 10 }}
//           >
//             Actualiser
//           </Button>
//         </Col>
//         {parseInt(localStorage.getItem("fonction_id")) === 1 && hasPermission(getPermissionsFromToken(), "CAMION_ADD") && (
//           <Col flex="0 0 auto">
//             <Button type="primary" icon={<PlusOutlined />} onClick={showModal} style={{ borderRadius: 10 }}>
//               Ajouter
//             </Button>
//           </Col>
//         )}
//         <Col flex="0 0 auto" style={{ marginLeft: "auto" }}>
//           <Button
//             type={isCardView ? "default" : "primary"}
//             icon={isCardView ? <TableOutlined /> : <AppstoreOutlined />}
//             onClick={() => setIsCardView(!isCardView)}
//             style={{ borderRadius: 10 }}
//           >
//             {isCardView ? "Vue Tableau" : "Vue Carte"}
//           </Button>
//         </Col>
//       </Row>

//       <div className="fleet-scroll" style={{ height: "62vh", overflowY: "auto" }}>
//         {isCardView ? (
//           <Row gutter={[0, 0]}>
//             {filteredCamions &&
//               filteredCamions.map((item) => {
//                 const statutColor = getStatutColor(item.statut_id);
//                 const appartenanceColor = APPARTENANCE_COLORS[item.appartenance_id] || "#d97706";
//                 const chauffeur = chauffeurListe.find((c) => c.id === item.chauffeur_id);
//                 const site = listeSite.find((s) => s.id === item.site_id);
//                 const statut = listeStatutCamion.find((s) => s.id === item.statut_id);
//                 const carburantPct = getCarburantPercent(item);
//                 const carburantColor = getCarburantColor(carburantPct);
//                 const alertes = getAlertesCamion(item);
//                 const image_url = config.REACT_APP_ENDPOINT_ + item["images"];

//                 return (
//                   <Col span={6} key={item.id} style={{ padding: 12 }}>
//                     <Card
//                       hoverable
//                       className="fleet-card"
//                       variant="borderless"
//                       style={{
//                         border: "1px solid #eef0f3",
//                         borderRadius: 16,
//                         overflow: "hidden",
//                       }}
//                       styles={{ body: { padding: 16 } }}
//                       cover={
//                         <div style={{ position: "relative" }}>
//                           <img
//                             src={image_url}
//                             alt="camion"
//                             draggable={false}
//                             style={{ width: "100%", height: 140, objectFit: "cover" }}
//                           />
//                           <Tag
//                             color={statutColor}
//                             style={{
//                               position: "absolute",
//                               top: 10,
//                               right: 10,
//                               border: "none",
//                               borderRadius: 20,
//                               padding: "2px 10px",
//                               fontWeight: 500,
//                             }}
//                           >
//                             {statut ? statut.nom : "-"}
//                           </Tag>
//                         </div>
//                       }
//                     >
//                       {/* Immatriculation + marque + appartenance/site */}
//                       <div style={{ marginBottom: 12 }}>
//                         <h4 style={{ marginBottom: 2, fontSize: 16 }}>{item.imm}</h4>
//                         <span style={{ color: "#9ca3af", fontSize: 12.5 }}>{item.marque}</span>
//                         <div style={{ display: "flex", alignItems: "center", gap: 6, marginTop: 8 }}>
//                           <Tag
//                             color={appartenanceColor}
//                             style={{ border: "none", borderRadius: 20, fontSize: 11 }}
//                           >
//                             {item.appartenance_id === 1 ? "Propre" : "Location"}
//                           </Tag>
//                           <EnvironmentOutlined style={{ color: "#9ca3af", fontSize: 12 }} />
//                           <span style={{ fontSize: 12.5, color: "#6b7280" }}>{site ? site.nom : "-"}</span>
//                         </div>
//                       </div>

//                       {/* Chauffeur */}
//                       <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 12 }}>
//                         {/* <Avatar size={28} style={{ background: "#eef2ff", color: "#4f46e5", fontSize: 12, fontWeight: 600 }}>
//                           {chauffeur ? getInitiales(chauffeur.nom, chauffeur.prenom) : <UserOutlined />}
//                         </Avatar> */}
//                         <span style={{ fontSize: 13, color: chauffeur ? "#374151" : "#c1c7d0" }}>
//                           {chauffeur ? `${chauffeur.nom} ${chauffeur.prenom}` : "Non assigné"}
//                         </span>
//                       </div>

//                       {/* Km + Carburant */}
//                       <Row gutter={12} style={{ marginBottom: 12 }}>
//                         <Col span={12}>
//                           <div style={{ fontSize: 11, color: "#9ca3af", marginBottom: 2 }}>
//                             <DashboardOutlined /> Kilométrage
//                           </div>
//                           <strong style={{ fontSize: 13.5 }}>{Number(item.kilometrage || 0).toLocaleString("fr-FR")} km</strong>
//                         </Col>
//                         <Col span={12}>
//                           <div style={{ fontSize: 11, color: "#9ca3af", marginBottom: 2 }}>
//                             <ThunderboltOutlined /> Carburant
//                           </div>
//                           <div style={{ display: "flex", justifyContent: "space-between", fontSize: 12 }}>
//                             <strong>{item.carburant} L</strong>
//                             <span style={{ color: carburantColor, fontWeight: 600 }}>{carburantPct}%</span>
//                           </div>
//                           <div style={{ height: 5, borderRadius: 4, background: "#f1f2f4", overflow: "hidden", marginTop: 3 }}>
//                             <div style={{ height: "100%", width: `${carburantPct}%`, background: carburantColor, borderRadius: 4 }} />
//                           </div>
//                         </Col>
//                       </Row>

//                       {/* Alertes : uniquement si pertinent, pas de surcharge d'info */}
//                       <div style={{ minHeight: 26, marginBottom: 4 }}>
//                         {alertes.length === 0 ? (
//                           <Tag icon={<CheckCircleFilled />} color="success" style={{ border: "none", borderRadius: 20 }}>
//                             Aucune alerte
//                           </Tag>
//                         ) : (
//                           <Space size={4} wrap>
//                             {alertes.map((a, i) => (
//                               <Tooltip key={i} title={`${a.type} — ${a.label}`}>
//                                 <Tag
//                                   icon={<ExclamationCircleFilled />}
//                                   color={a.level === "expired" ? "error" : "warning"}
//                                   style={{ border: "none", borderRadius: 20, fontSize: 11 }}
//                                 >
//                                   {a.type}
//                                 </Tag>
//                               </Tooltip>
//                             ))}
//                           </Space>
//                         )}
//                       </div>

//                       <Divider style={{ margin: "10px 0" }} />

//                       {/* Actions */}
//                       {parseInt(localStorage.getItem("fonction_id")) === 1 && (
//                         <div style={{ display: "flex", justifyContent: "center", gap: 10 }}>
//                           {hasPermission(getPermissionsFromToken(), "CAMION_EDIT") && (
//                             <Tooltip title="Éditer le camion">
//                               <Button
//                                 type="text"
//                                 icon={<EditFilled style={{ fontSize: 17, color: "#faad14" }} />}
//                                 onClick={() => handleEditCamion(item)}
//                               />
//                             </Tooltip>
//                           )}
//                           {hasPermission(getPermissionsFromToken(), "CAMION_DELETE") && (
//                             <Tooltip title="Supprimer le camion">
//                               <Button
//                                 type="text"
//                                 danger
//                                 icon={<DeleteOutlined style={{ fontSize: 17 }} />}
//                                 onClick={() => handleDelete(item)}
//                               />
//                             </Tooltip>
//                           )}
//                           {hasPermission(getPermissionsFromToken(), "CAMION_EXPORT") && (
//                             <Tooltip title="Exporter les données">
//                               <Button
//                                 type="text"
//                                 icon={<ExportOutlined style={{ fontSize: 17, color: "#1677ff" }} />}
//                                 onClick={() => {
//                                   setselectedCamion(item);
//                                   setisExportModal(true);
//                                 }}
//                               />
//                             </Tooltip>
//                           )}
//                           {hasPermission(getPermissionsFromToken(), "CAMION_CALIBRAGE") && (
//                             <Tooltip title="Calibrage du camion">
//                               <Button
//                                 type="text"
//                                 icon={<ShrinkOutlined style={{ fontSize: 17, color: "#6c757d" }} />}
//                                 onClick={() => {
//                                   setselectedCamion(item);
//                                   setshowModalCallibrage(true);
//                                 }}
//                               />
//                             </Tooltip>
//                           )}
//                           {hasPermission(getPermissionsFromToken(), "CAMION_CONSOMMATION") && (
//                             <Tooltip title="Consommation carburant">
//                               <Button
//                                 type="text"
//                                 icon={<LineChartOutlined style={{ fontSize: 17, color: "#16a34a" }} />}
//                                 onClick={() => {
//                                   setselectedCamion(item);
//                                   setisConsommationModalOpen(true);
//                                 }}
//                               />
//                             </Tooltip>
//                           )}
//                         </div>
//                       )}
//                     </Card>
//                   </Col>
//                 );
//               })}
//           </Row>
//         ) : (
//           <Table
//             dataSource={filteredCamions}
//             columns={columns}
//             rowKey="id"
//             scroll={{ x: 1100 }}
//             pagination={{
//               pageSize: 8,
//               position: ["bottomCenter"],
//               className: "custom-pagination",
//               style: {
//                 display: "flex",
//                 justifyContent: "center",
//                 marginTop: 12,
//               },
//               itemRender: (page, type, originalElement) => {
//                 if (type === "page") {
//                   return (
//                     <div
//                       style={{
//                         borderRadius: "50%",
//                         minWidth: 32,
//                         height: 32,
//                         display: "flex",
//                         alignItems: "center",
//                         justifyContent: "center",
//                         border: "1px solid #d9d9d9",
//                       }}
//                     >
//                       {page}
//                     </div>
//                   );
//                 }
//                 return originalElement;
//               },
//             }}
//           />
//         )}
//       </div>

//       <Modal
//         // title="Supprimer ce camion"
//         open={isModalDisableOpen}
//         onOk={handleOkDisable}
//         onCancel={() => {
//           setisModalDisableOpen(false);
//         }}
//         okText="Supprimer"
//         cancelText="Annuler"
//         width={800} // largeur plus grande pour bien aligner
//         style={{ top: 10 }}
//         confirmLoading={isLoading}
//       >
//         <Row>
//           <h4>
//             Voulez vous vraiment supprimer le camion {selectedCamion.imm} de vos
//             flotte ?
//           </h4>
//         </Row>
//       </Modal>

//       <Modal
//         title="Export"
//         open={isExportModal}
//         onCancel={() => setisExportModal(false)}
//         footer={null}
//         width={800}
//         style={{ top: 10 }}
//       >
//         <div style={{ padding: 20 }}>
//           <Row gutter={[0, 20]}>
//             <Col span={24}>
//               <p>Sélectionnez la période :</p>
//               <RangePicker
//                 showTime
//                 onChange={(values) =>
//                   setexportdata({ ...exportdata, dates: values })
//                 }
//                 style={{ width: "100%" }}
//                 format="YYYY-MM-DD HH:mm:ss"
//               />
//             </Col>

//             <Col span={24}>
//               <p>Choisissez le type d'export :</p>
//               <Radio.Group
//                 onChange={(e) =>
//                   setexportdata({ ...exportdata, type: e.target.value })
//                 }
//                 value={exportdata.type}
//                 style={{ width: "100%" }}
//               >
//                 <Row>
//                   <Col span={12}>
//                     <Radio value="entretien">
//                       <span style={{ fontSize: 15 }}>Export Entretien</span>
//                     </Radio>
//                   </Col>
//                   <Col span={12}>
//                     <Radio value="trajet">
//                       <span style={{ fontSize: 15 }}>Export Trajet</span>
//                     </Radio>
//                   </Col>
//                 </Row>
//               </Radio.Group>
//             </Col>

//             <Col span={24} style={{ textAlign: "right" }}>
//               <Space>
//                 <Button onClick={() => setisExportModal(false)}>Annuler</Button>
//                 <Button
//                   loading={isLoading}
//                   type="primary"
//                   onClick={handleExport}
//                   disabled={!exportdata.dates || !exportdata.type}
//                 >
//                   Exporter
//                 </Button>
//               </Space>
//             </Col>
//           </Row>
//         </div>
//       </Modal>

//       <Modal
//         title="Calibrage"
//         open={showModalCallibrage}
//         onCancel={() => {
//           setcurrentCallibrage([{ x: 0, y: 0 }]);
//           setselectedCamion({
//             id: null,
//             imm: "",
//             imm_rem: "",
//             reference: "",
//             marque: "",
//             fond_cuve: 0,
//             carburant: 0,
//             lim_vt: null,
//             lim_ass: null,
//             energie_id: 0,
//             chauffeur_id: 0,
//             type_id: 0,
//             appartenance_id: 0,
//             site_id: 0,
//             kilometrage: 0,
//             images: null,
//             dernier_date_vidange: null,
//             intervalle_km_vidange: null,
//             dernier_km_vidange: 0,
//           });
//           setshowModalCallibrage(false);
//         }}
//         footer={null}
//         width={800}
//         style={{ top: 10 }}
//       >
//         <div style={{ padding: 5, height: "60vh", overflowY: "auto" }}>
//           {currentCallibrage.map((item, index) => (
//             <Row key={index} gutter={[10, 10]} align="middle">
//               <Col span={10}>
//                 <p>Valeur X :</p>
//                 <InputNumber
//                   size="small"
//                   style={{ width: "100%" }}
//                   step={0.01}
//                   min={0}
//                   value={item.x}
//                   onChange={(value) =>
//                     handleChangeCallibrage(index, "x", value)
//                   }
//                 />
//               </Col>
//               <Col span={10}>
//                 <p>Valeur Y :</p>
//                 <InputNumber
//                   size="small"
//                   style={{ width: "100%" }}
//                   step={0.01}
//                   min={0}
//                   value={item.y}
//                   onChange={(value) =>
//                     handleChangeCallibrage(index, "y", value)
//                   }
//                 />
//               </Col>
//               <Col span={4} style={{ textAlign: "center" }}>
//                 {currentCallibrage.length > 1 && (
//                   <Button
//                     type="text"
//                     danger
//                     icon={<DeleteOutlined />}
//                     onClick={() => handleRemoveRow(index)}
//                   />
//                 )}
//               </Col>
//             </Row>
//           ))}

//           <Button
//             type="dashed"
//             icon={<PlusOutlined />}
//             onClick={handleAddRow}
//             style={{ width: "100%", marginTop: 20 }}
//           >
//             Ajouter une ligne
//           </Button>

//           <Row style={{ marginTop: 30 }}>
//             <Col span={12}></Col>
//             <Col span={12} style={{ textAlign: "right" }}>
//               <Space>
//                 <Button onClick={() => setshowModalCallibrage(false)}>
//                   Annuler
//                 </Button>
//                 <Button
//                   loading={isLoading}
//                   type="primary"
//                   onClick={handleAddCalibrage}
//                 >
//                   Enregistrer
//                 </Button>
//               </Space>
//             </Col>
//           </Row>
//         </div>
//       </Modal>

//       <Modal
//         title={`Consommation carburant — ${selectedCamion?.imm || ""}`}
//         open={isConsommationModalOpen}
//         onCancel={() => setisConsommationModalOpen(false)}
//         footer={null}
//         width={"92%"}
//         style={{ top: 10 }}
//         bodyStyle={{ maxHeight: "82vh", overflowY: "auto", padding: 0 }}
//         destroyOnClose
//       >
//         {selectedCamion?.id && (
//           <ConsommationCarburant camionIdLocked={selectedCamion.id} />
//         )}
//       </Modal>

//       {showToast && (
//         <Notification message={notif.message} status={notif.info} />
//       )}
//       <Modal
//         title={titleModal}
//         open={isModalOpen}
//         onOk={handleOk}
//         onCancel={handleCancel}
//         okText="Enregistrer"
//         cancelText="Annuler"
//         width={"85%"}
//         style={{ top: 10 }}
//         bodyStyle={{ maxHeight: "75vh", overflowY: "auto", paddingRight: 8 }}
//         confirmLoading={isLoading}
//       >
//         <Row gutter={[12, 16]}>
//           <Col span={6}>
//             <p style={{ marginBottom: 4 }}>
//               Immatriculation <span style={{ color: "red" }}>*</span>
//             </p>
//             <Input
//               size="medium"
//               name="imm"
//               value={selectedCamion?.imm || ""}
//               onChange={handleChangeForm}
//             />
//           </Col>

//           <Col span={6}>
//             <p style={{ marginBottom: 4 }}>Immatriculation R</p>
//             <Input
//               size="medium"
//               name="imm_rem"
//               value={selectedCamion?.imm_rem || ""}
//               onChange={handleChangeForm}
//             />
//           </Col>

//           <Col span={6}>
//             <p style={{ marginBottom: 4 }}>Reference</p>
//             <Input
//               size="medium"
//               name="reference"
//               value={selectedCamion?.reference || ""}
//               onChange={handleChangeForm}
//             />
//           </Col>

//           <Col span={6}>
//             <p style={{ marginBottom: 4 }}>Marque</p>
//             <Input
//               size="medium"
//               name="marque"
//               value={selectedCamion?.marque || ""}
//               onChange={handleChangeForm}
//             />
//           </Col>

//           <Col span={6}>
//             <p style={{ marginBottom: 4 }}>Carte grise</p>
//             <Input
//               size="medium"
//               name="num_carte_grise"
//               value={selectedCamion?.num_carte_grise || ""}
//               onChange={handleChangeForm}
//             />
//           </Col>

//           <Col span={6}>
//             <p style={{ marginBottom: 4 }}>Patente</p>
//             <Input
//               size="medium"
//               name="num_patente"
//               value={selectedCamion?.num_patente || ""}
//               onChange={handleChangeForm}
//             />
//           </Col>

//           <Col span={6}>
//             <p style={{ marginBottom: 4 }}>Fond de cuve</p>
//             <Input
//               size="medium"
//               name="fond_cuve"
//               value={selectedCamion?.fond_cuve || 0}
//               onChange={handleChangeForm}
//             />
//           </Col>

//           <Col span={6}>
//             <p style={{ marginBottom: 4 }}>Carburant</p>
//             <Input
//               size="medium"
//               name="carburant"
//               value={selectedCamion?.carburant || 0}
//               onChange={handleChangeForm}
//             />
//           </Col>

//           <Col span={6}>
//             <p style={{ marginBottom: 4 }}>Kilometrage actuelle</p>
//             <Input
//               size="medium"
//               name="kilometrage"
//               value={selectedCamion?.kilometrage || 0}
//               onChange={handleChangeForm}
//             />
//           </Col>

//           <Col span={6}>
//             <p style={{ marginBottom: 4 }}>Kilometrage vidange</p>
//             <Input
//               size="medium"
//               name="dernier_km_vidange"
//               value={selectedCamion?.dernier_km_vidange || 0}
//               onChange={handleChangeForm}
//             />
//           </Col>

//           <Col span={6}>
//             <p style={{ marginBottom: 4 }}>Intervalle vidange</p>
//             <Input
//               size="medium"
//               name="intervalle_km_vidange"
//               value={selectedCamion?.intervalle_km_vidange || 0}
//               onChange={handleChangeForm}
//             />
//           </Col>

//           <Col span={6}>
//             <p style={{ marginBottom: 4 }}>Date limite visite technique</p>
//             <DatePicker
//               style={{ width: "100%" }}
//               format="YYYY-MM-DD"
//               placeholder="Sélectionner une date"
//               value={selectedCamion.lim_vt || null}
//               onChange={(date) =>
//                 setselectedCamion({ ...selectedCamion, lim_vt: date })
//               }
//             />
//           </Col>

//           <Col span={6}>
//             <p style={{ marginBottom: 4 }}>Date limite assurance</p>
//             <DatePicker
//               style={{ width: "100%" }}
//               format="YYYY-MM-DD"
//               placeholder="Sélectionner une date"
//               value={selectedCamion.lim_ass || null}
//               onChange={(date) =>
//                 setselectedCamion({ ...selectedCamion, lim_ass: date })
//               }
//             />
//           </Col>

//           <Col span={6}>
//             <p style={{ marginBottom: 4 }}>Date dernier vidange</p>
//             <DatePicker
//               style={{ width: "100%" }}
//               format="YYYY-MM-DD"
//               placeholder="Sélectionner une date"
//               value={selectedCamion.dernier_date_vidange || null}
//               onChange={(date) =>
//                 setselectedCamion({
//                   ...selectedCamion,
//                   dernier_date_vidange: date,
//                 })
//               }
//             />
//           </Col>

//           <Col span={6}>
//             <p style={{ marginBottom: 4 }}>Energie</p>
//             <ListeEnergie
//               valeur={selectedCamion.energie_id}
//               onchange={(value) =>
//                 setselectedCamion({ ...selectedCamion, energie_id: value })
//               }
//             />
//           </Col>

//           <Col span={6}>
//             <p style={{ marginBottom: 4 }}>Type</p>
//             <ListeType
//               valeur={selectedCamion.type_id}
//               onchange={(value) =>
//                 setselectedCamion({ ...selectedCamion, type_id: value })
//               }
//             />
//           </Col>

//           <Col span={6}>
//             <p style={{ marginBottom: 4 }}>Chauffeur</p>
//             <ListeChauffeur
//               valeur={selectedCamion.chauffeur_id}
//               onchange={(value) =>
//                 setselectedCamion({ ...selectedCamion, chauffeur_id: value })
//               }
//               data={chauffeurListe}
//             />
//           </Col>

//           <Col span={6}>
//             <p style={{ marginBottom: 4 }}>Situation</p>
//             <ListeAppartenance
//               valeur={selectedCamion.appartenance_id}
//               onchange={(value) =>
//                 setselectedCamion({ ...selectedCamion, appartenance_id: value })
//               }
//             />
//           </Col>

//           <Col span={6}>
//             <p style={{ marginBottom: 4 }}>Site</p>
//             <ListeSite
//               valeur={selectedCamion.site_id}
//               onchange={(value) =>
//                 setselectedCamion({ ...selectedCamion, site_id: value })
//               }
//             />
//           </Col>

//           <Col span={6}>
//             <p style={{ marginBottom: 4 }}>Image</p>
//             <input type="file" accept="image/*" onChange={handleFileChange} />
//           </Col>
//         </Row>
//       </Modal>

//     </div>
//   );
// };

// export default Camion;

import {
  Button,
  Modal,
  Input,
  Card,
  DatePicker,
  Row,
  Col,
  message,
  Radio,
  Tag,
  Space,
  Table,
  InputNumber,
  Divider,
  Tooltip,
  Progress,
  Avatar,
} from "antd";
import React, { useEffect, useState } from "react";
import ListeChauffeur from "../../../composants/ListeChauffeur";
import ListeEnergie from "../../../composants/ListeEnergie";
import ListeAppartenance from "../../../composants/ListeAppartenance";
import ListeType from "../../../composants/ListeType";
import ListeSite from "../../../composants/ListeSite";
import moment from "moment";
import "moment/locale/fr";
import {
  addCallibrage,
  createCamion,
  disableCamion,
  exportCamion,
  get_listeCamion,
  updateCamion,
} from "../../../api/camion";
import { get_ListeSite } from "../../../api/site";
import {
  EnvironmentOutlined,
  WarningOutlined,
  DashboardOutlined,
  AreaChartOutlined,
  ApiOutlined,
  EditFilled,
  BgColorsOutlined,
  AppstoreOutlined,
  TableOutlined,
  DeleteOutlined,
  ExportOutlined,
  ShrinkOutlined,
  PlusOutlined,
  UserOutlined,
  ThunderboltOutlined,
  ExclamationCircleFilled,
  CheckCircleFilled,
  SearchOutlined,
  ReloadOutlined,
  LineChartOutlined,
  FileExcelOutlined,
} from "@ant-design/icons";

import { get_ListeChauffeur } from "../../../api/chauffeur";
import * as config from "../../../config/config";
import { get_ListeStatut } from "../../../api/statut";
import ListeStatut from "../../../composants/ListeStatut";
import formatDateFr, { getPermissionsFromToken, hasPermission } from "../../../utils/utils";
import Notification from "../../../composants/Notification";
// NOTE : adapte ce chemin selon l'emplacement réel de ConsommationCarburant.jsx
// (ici on suppose src/pages/dashboard/ConsommationCarburant.jsx)
import ConsommationCarburant from "./ConsommationCarburant";
import {
  export_ConsommationCarburant as exportPerformanceCamions
} from '../../../api/dashboard'
const { RangePicker } = DatePicker;

// ---- Palette & helpers de statut / alertes -------------------------------

const STATUT_COLORS = {
  1: "#2563eb", // en service
  2: "#ef4444", // hors service
  3: "#16a34a", // disponible
  4: "#f59e0b", // maintenance
};
const getStatutColor = (id) => STATUT_COLORS[id] || "#94a3b8";

const APPARTENANCE_COLORS = {
  1: "#16a34a", // propre
  2: "#d97706", // location
};

// Renvoie une alerte { level: 'expired' | 'warning', label } ou null
const getDateAlerte = (dateStr, seuilJours = 30) => {
  if (!dateStr) return null;
  const diff = moment(dateStr).startOf("day").diff(moment().startOf("day"), "days");
  if (diff < 0) return { level: "expired", label: "Expiré" };
  if (diff <= seuilJours) return { level: "warning", label: `${diff} j restants` };
  return null;
};

// Regroupe toutes les alertes pertinentes d'un camion (docs + vidange)
const getAlertesCamion = (item) => {
  const alertes = [];
  const assurance = getDateAlerte(item.date_assurance);
  if (assurance) alertes.push({ ...assurance, type: "Assurance" });

  const visite = getDateAlerte(item.date_visite_technique);
  if (visite) alertes.push({ ...visite, type: "Visite technique" });

  if (item.dernier_km_vidange && item.intervalle_km_vidange) {
    const kmRestant =
      item.dernier_km_vidange + item.intervalle_km_vidange - (item.kilometrage || 0);
    if (kmRestant <= 0) {
      alertes.push({ level: "expired", label: "Dépassée", type: "Vidange" });
    } else if (kmRestant <= 500) {
      alertes.push({ level: "warning", label: `Dans ${kmRestant} km`, type: "Vidange" });
    }
  }
  return alertes;
};

const getCarburantPercent = (item) => {
  if (!item.fond_cuve || item.fond_cuve === 0) return 0;
  return Math.min(100, Math.round(((item.carburant || 0) / item.fond_cuve) * 100));
};

const getCarburantColor = (pct) => (pct < 20 ? "#ef4444" : pct < 50 ? "#f59e0b" : "#16a34a");

const getInitiales = (nom, prenom) =>
  `${nom?.[0] || ""}${prenom?.[0] || ""}`.toUpperCase() || "?";

const Camion = ({ liste_camion }) => {
  const permissions = getPermissionsFromToken();
  const [isCardView, setIsCardView] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalDisableOpen, setisModalDisableOpen] = useState(false);
  const [listeCamion, setlisteCamion] = useState([]);
  const [chauffeurListe, setchauffeurListe] = useState([]);
  const [listeStatutCamion, setlisteStatutCamion] = useState([]);
  const [selectedCamion, setselectedCamion] = useState({
    id: null,
    imm: "",
    imm_rem: "",
    reference: "",
    marque: "",
    fond_cuve: 0,
    carburant: 0,
    lim_vt: null,
    lim_ass: null,
    energie_id: 0,
    chauffeur_id: 0,
    type_id: 0,
    appartenance_id: 0,
    site_id: 0,
    kilometrage: 0,
    images: null,
    dernier_date_vidange: null,
    intervalle_km_vidange: null,
    dernier_km_vidange: 0,
    num_carte_grise: null,
    num_patente: null
  });
  const [search, setSearch] = useState("");
  const [searchStatut, setsearchStatut] = useState(null);
  const [listeSite, setlisteSite] = useState([]);
  const [titleModal, settitleModal] = useState("Ajouter un camion");
  const [isUpdate, setisUpdate] = useState(false);
  const [isExportModal, setisExportModal] = useState(false);
  const [isExportAllModal, setisExportAllModal] = useState(false);
  const [exportAllDates, setexportAllDates] = useState(null);
  const [filteredCamions, setfilteredCamions] = useState([]);
  const [isLoading, setisLoading] = useState(false);
  const [exportdata, setexportdata] = useState({
    dates: null,
    type: null,
  });
  const [showToast, setshowToast] = useState(false);
  const [notif, setnotif] = useState({
    message: null,
    info: null,
  });
  const [showModalCallibrage, setshowModalCallibrage] = useState(false);
  const [isConsommationModalOpen, setisConsommationModalOpen] = useState(false);
  const [currentCallibrage, setcurrentCallibrage] = useState([
    {
      x: 0,
      y: 0,
    },
  ]);
  useEffect(() => {
    fetchListeCamion();
    fetchListeChauffeur();
    fetchListeSite();
    fetchListeStatut();
  }, []);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = async () => {
    try {
      setisLoading(true);
      const isUpdateMode = Boolean(isUpdate);
      const payload = {
        ...selectedCamion,
        lim_vt: selectedCamion.lim_vt
          ? moment(selectedCamion.lim_vt).format("YYYY-MM-DD HH:mm:ss")
          : null,
        lim_ass: selectedCamion.lim_ass
          ? moment(selectedCamion.lim_ass).format("YYYY-MM-DD HH:mm:ss")
          : null,
      };

      const action = isUpdateMode ? updateCamion : createCamion;
      const successMsg = isUpdateMode
        ? "Camion mis à jour avec succès 🚚"
        : "Camion créé avec succès 🚛";
      const errorMsg = isUpdateMode
        ? "Erreur lors de la mise à jour du camion ❌"
        : "Erreur lors de la création du camion ❌";

      const res = await action(payload);

      if (res?.status === "success") {
        message.success(successMsg, 2);
        setnotif({
          ...notif,
          message: successMsg,
          info: "success",
        });
        setshowToast(true);
        setTimeout(() => window.location.reload(), 2000);
      } else {
        message.error(errorMsg, 2);
        setnotif({
          ...notif,
          message: errorMsg,
          info: "error",
        });
        setshowToast(true);
        setTimeout(() => window.location.reload(), 2000);
      }
    } catch (err) {
      console.error("Erreur handleOk:", err);
      message.error("Une erreur inattendue est survenue ❗", 2);
    }
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    settitleModal("Ajouter un camion");
    setisUpdate(false);
    setselectedCamion({
      id: null,
      imm: "",
      imm_rem: "",
      reference: "",
      marque: "",
      fond_cuve: 0,
      carburant: 0,
      lim_vt: null,
      lim_ass: null,
      energie_id: 0,
      chauffeur_id: 0,
      type_id: 0,
      appartenance_id: 0,
      site_id: 0,
      kilometrage: 0,
      images: null,
      dernier_date_vidange: null,
      intervalle_km_vidange: null,
      dernier_km_vidange: 0,
      num_carte_grise: null,
      num_patente: null
    });
  };

  const handleChangeForm = (e) => {
    const value = e.target.value;
    setselectedCamion({
      ...selectedCamion,
      [e.target.name]: value,
    });
  };

  const fetchListeCamion = async () => {
    const res = await get_listeCamion();
    if (res.status === "success") {
      setlisteCamion(res.data);
      setfilteredCamions(res.data);
    }
  };

  const fetchListeSite = async () => {
    const res = await get_ListeSite();
    if (res.status === "success") {
      setlisteSite(res.data);
    }
  };

  const fetchListeStatut = async () => {
    const res = await get_ListeStatut();
    if (res.status === "success") {
      setlisteStatutCamion(res.data);
    }
  };

  const fetchListeChauffeur = async () => {
    const res = await get_ListeChauffeur();
    if (res.status === "success") {
      setchauffeurListe(res.data);
    }
  };

  const handleSearchTexteCamion = (e) => {
    let text = e.target.value;
    setSearch(text);
    console.log(text.length);
    if (text.length === 0) {
      setfilteredCamions(listeCamion);
      setsearchStatut(0);
    } else {
      let mon_filtre = filteredCamions.filter(
        (camion) =>
          camion.imm.toLowerCase().includes(search.toLowerCase()) ||
          camion.marque.toLowerCase().includes(search.toLowerCase())
      );
      setfilteredCamions(mon_filtre);
    }
  };

  const handleSearchStatutCamion = (value) => {
    setSearch(0);
    setfilteredCamions(listeCamion);
    if (value === null || value === 0) {
      setfilteredCamions(listeCamion);
    } else {
      let mon_filtre = listeCamion.filter(
        (camion) => camion.statut_id === value
      );
      console.log(mon_filtre);
      setfilteredCamions(mon_filtre);
    }
  };

  const handleReload = () => {
    setisLoading(true);
    setTimeout(() => {
      window.location.reload();
    }, 2);
  };

  const handleEditCamion = (item) => {
    settitleModal("Mettre à jour un camion");
    setisUpdate(true);
    setselectedCamion({
      ...selectedCamion,
      id: item.id,
      imm: item.imm,
      imm_rem: item.imm_remorque,
      reference: item.reference,
      marque: item.marque,
      fond_cuve: item.fond_cuve,
      carburant: item.carburant,
      lim_vt: item.date_visite_technique
        ? moment(item.date_visite_technique)
        : null,
      lim_ass: item.date_assurance ? moment(item.date_assurance) : null,
      energie_id: item.energie_id,
      chauffeur_id: item.chauffeur_id,
      type_id: item.type_id,
      appartenance_id: item.appartenance_id,
      site_id: item.site_id,
      kilometrage: item.kilometrage,
      images: null,
      dernier_date_vidange: item.dernier_date_vidange
        ? moment(item.dernier_date_vidange)
        : null,
      intervalle_km_vidange: item.intervalle_km_vidange,
      dernier_km_vidange: item.dernier_km_vidange,
      num_carte_grise: item.num_carte_grise,
      num_patente: item.num_patente
    });
    showModal(true);
  };

  // gestion fichier
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setselectedCamion((prev) => ({
          ...prev,
          images: reader.result, // base64
        }));
      };
      reader.readAsDataURL(file);
    }
  };

  const handleDelete = (item) => {
    setselectedCamion(item);
    setisModalDisableOpen(true);
  };

  const handleOkDisable = async () => {
    setisLoading(true);
    const res = await disableCamion(selectedCamion.id);
    if (res.status === "success") {
      message.success("Camion supprimé avec success !!!", 2);
    } else {
      message.warning("Camion non supprimé !!!", 2);
    }
    setTimeout(() => {
      window.location.reload();
    }, 1500);
  };

  const handleExport = async () => {
    setisLoading(true);
    await exportCamion(selectedCamion.id, exportdata);
    setisLoading(false);
  };

  // ---- Export performance de tous les camions (sans camion_id) ----
  const handleCloseExportAll = () => {
    setisExportAllModal(false);
    setexportAllDates(null);
  };

  const handleExportAll = async () => {
    if (!exportAllDates || !exportAllDates[0] || !exportAllDates[1]) {
      message.warning("Veuillez sélectionner la date de début et la date de fin", 2);
      return;
    }
    try {
      setisLoading(true);
      const res = await exportPerformanceCamions({
        start_date: moment(exportAllDates[0]).format("YYYY-MM-DD"),
        end_date: moment(exportAllDates[1]).format("YYYY-MM-DD"),
      });
      if (res?.status === "success") {
        message.success("Export généré avec succès 📊", 2);
        handleCloseExportAll();
      } else {
        message.error("Erreur lors de l'export ❌", 2);
      }
    } catch (err) {
      console.error("Erreur handleExportAll:", err);
      message.error("Une erreur inattendue est survenue ❗", 2);
    } finally {
      setisLoading(false);
    }
  };

  // ---- Colonnes du tableau : infos essentielles visibles sans "Éditer" ----
  const columns = [
    {
      title: "Véhicule",
      dataIndex: "imm",
      key: "imm",
      fixed: "left",
      width: 170,
      render: (imm, record) => (
        <div>
          <div style={{ fontWeight: 600, fontSize: 13.5, color: "#1f2937" }}>{imm}</div>
          <div style={{ fontSize: 12, color: "#9ca3af" }}>{record.marque}</div>
        </div>
      ),
    },
    {
      title: "Chauffeur",
      dataIndex: "chauffeur_id",
      key: "chauffeur_id",
      render: (id) => {
        const ch = chauffeurListe.find((c) => c.id === id);
        if (!ch) return <span style={{ color: "#c1c7d0", fontSize: 13 }}>Non assigné</span>;
        return (
          <Space size={8}>
            {/* <Avatar size={26} style={{ background: "#eef2ff", color: "#4f46e5", fontSize: 11, fontWeight: 600 }}>
              {getInitiales(ch.nom, ch.prenom)}
            </Avatar> */}
            <span style={{ fontSize: 13 }}>{ch.nom} {ch.prenom}</span>
          </Space>
        );
      },
    },
    {
      title: "Site",
      dataIndex: "site_id",
      key: "site_id",
      render: (id) => {
        const site = listeSite.find((s) => s.id === id);
        return (
          <Space size={4}>
            <EnvironmentOutlined style={{ color: "#9ca3af" }} />
            <span style={{ fontSize: 13 }}>{site ? site.nom : "-"}</span>
          </Space>
        );
      },
    },
    {
      title: "Kilométrage",
      dataIndex: "kilometrage",
      key: "kilometrage",
      sorter: (a, b) => (a.kilometrage || 0) - (b.kilometrage || 0),
      render: (val) => <span style={{ fontSize: 13 }}>{Number(val || 0).toLocaleString("fr-FR")} km</span>,
    },
    {
      title: "Carburant",
      key: "carburant",
      width: 120,
      render: (_, record) => {
        const pct = getCarburantPercent(record);
        const color = getCarburantColor(pct);
        return (
          <div style={{ minWidth: 90 }}>
            <div style={{ display: "flex", justifyContent: "space-between", fontSize: 11.5, color: "#6b7280", marginBottom: 3 }}>
              <span>{record.carburant} L</span>
              <span style={{ color, fontWeight: 600 }}>{pct}%</span>
            </div>
            <div style={{ height: 5, borderRadius: 4, background: "#f1f2f4", overflow: "hidden" }}>
              <div style={{ height: "100%", width: `${pct}%`, background: color, borderRadius: 4, transition: "width .3s" }} />
            </div>
          </div>
        );
      },
    },
    {
      title: "Statut",
      dataIndex: "statut_id",
      key: "statut_id",
      render: (id) => {
        const stat = listeStatutCamion.find((s) => s.id === id);
        return (
          <Tag color={getStatutColor(id)} style={{ borderRadius: 20, border: "none", padding: "1px 10px", fontWeight: 500 }}>
            {stat ? stat.nom : "-"}
          </Tag>
        );
      },
    },
    {
      title: "Alertes",
      key: "alertes",
      width: 150,
      render: (_, record) => {
        const alertes = getAlertesCamion(record);
        if (alertes.length === 0) {
          return (
            <Tag icon={<CheckCircleFilled />} color="success" style={{ borderRadius: 20, border: "none" }}>
              OK
            </Tag>
          );
        }
        return (
          <Space direction="vertical" size={3}>
            {alertes.slice(0, 2).map((a, i) => (
              <Tooltip key={i} title={`${a.type} — ${a.label}`}>
                <Tag
                  icon={<ExclamationCircleFilled />}
                  color={a.level === "expired" ? "error" : "warning"}
                  style={{ borderRadius: 20, border: "none", fontSize: 11 }}
                >
                  {a.type}
                </Tag>
              </Tooltip>
            ))}
          </Space>
        );
      },
    },
    {
      title: "Actions",
      key: "actions",
      fixed: "right",
      width: 150,
      render: (_, record) => (
        <Space size={2}>
          {hasPermission(getPermissionsFromToken(), "CAMION_EDIT") && (
            <Tooltip title="Éditer">
              <Button
                type="text"
                size="small"
                icon={<EditFilled style={{ color: "#faad14" }} />}
                onClick={() => handleEditCamion(record)}
              />
            </Tooltip>
          )}
          {hasPermission(getPermissionsFromToken(), "CAMION_DELETE") && (
            <Tooltip title="Supprimer">
              <Button
                type="text"
                size="small"
                danger
                icon={<DeleteOutlined />}
                onClick={() => handleDelete(record)}
              />
            </Tooltip>
          )}
          {hasPermission(getPermissionsFromToken(), "CAMION_EXPORT") && (
            <Tooltip title="Exporter">
              <Button
                type="text"
                size="small"
                icon={<ExportOutlined style={{ color: "#1677ff" }} />}
                onClick={() => {
                  setselectedCamion(record);
                  setisExportModal(true);
                }}
              />
            </Tooltip>
          )}
          {hasPermission(getPermissionsFromToken(), "CAMION_CONSOMMATION") && (
            <Tooltip title="Consommation carburant">
              <Button
                type="text"
                size="small"
                icon={<LineChartOutlined style={{ color: "#16a34a" }} />}
                onClick={() => {
                  setselectedCamion(record);
                  setisConsommationModalOpen(true);
                }}
              />
            </Tooltip>
          )}
        </Space>
      ),
    },
  ];

  const handleAddCalibrage = async () => {
    setisLoading(true);
    if (
      !selectedCamion?.id ||
      !currentCallibrage ||
      currentCallibrage.length === 0 ||
      currentCallibrage.some((item) => item.x === null || item.y === null)
    ) {
      setnotif({
        ...notif,
        message: "Champs obligatoires manquants !!!",
        info: "warning",
      });
      setshowToast(true);
      setTimeout(() => setisLoading(false), 1500);
      return;
    }

    try {
      const promises = currentCallibrage.map((item) =>
        addCallibrage(selectedCamion.id, item)
      );

      const results = await Promise.all(promises);

      // Vérifier si tout est OK
      const allSuccess = results.every((r) => r?.status === "success");

      if (allSuccess) {
        setnotif({
          ...notif,
          message: "Tous les calibrages ont été insérés avec succès ✅",
          info: "success",
        });
        setshowToast(true);
        setTimeout(() => window.location.reload(), 1500);
      } else {
        setnotif({
          ...notif,
          message: "Certaines insertions ont échoué ❌",
          info: "error",
        });
        setshowToast(true);
        setisLoading(false);
      }
    } catch (error) {
      console.error(error);
      setnotif({
        ...notif,
        message: "Erreur lors de l’insertion des calibrages",
        info: "error",
      });
      setshowToast(true);
      setTimeout(() => setisLoading(false), 1500);
    }
  };

  const handleAddRow = () => {
    setcurrentCallibrage([...currentCallibrage, { x: 0, y: 0 }]);
  };

  const handleRemoveRow = (index) => {
    const newList = currentCallibrage.filter((_, i) => i !== index);
    setcurrentCallibrage(newList);
  };

  const handleChangeCallibrage = (index, field, value) => {
    const newList = [...currentCallibrage];
    newList[index][field] = value;
    setcurrentCallibrage(newList);
  };

  return (
    <div style={{ overflow: "hidden" }}>
      {/* Styles locaux : hover cartes + scrollbar + tag sans bordure */}
      <style>{`
        .fleet-card {
          transition: transform .18s ease, box-shadow .18s ease;
          box-shadow: 0 1px 2px rgba(16,24,40,.05);
        }
        .fleet-card:hover {
          transform: translateY(-3px);
          box-shadow: 0 12px 24px -8px rgba(16,24,40,.14);
        }
        .fleet-toolbar .ant-input-affix-wrapper,
        .fleet-toolbar .ant-select-selector {
          border-radius: 10px !important;
        }
        .fleet-scroll::-webkit-scrollbar { width: 6px; }
        .fleet-scroll::-webkit-scrollbar-thumb { background: #e2e5ea; border-radius: 8px; }
      `}</style>

      {/* ---- Header ---- */}
      <Row align="middle" justify="space-between">
        <Col>
          <h3 style={{ marginBottom: 2, fontSize: 20 }}>
            <strong>Gestion des camions</strong>
          </h3>
          <p style={{ margin: 0, color: "#8c8c8c" }}>
            {listeCamion && listeCamion.length > 0
              ? `${listeCamion.length} ${listeCamion.length > 1 ? "camions" : "camion"} dans votre flotte`
              : "Aucun camion dans votre flotte"}
          </p>
        </Col>
      </Row>

      {/* ---- Toolbar ---- */}
      <Row
        className="fleet-toolbar"
        align="middle"
        gutter={[12, 12]}
        style={{
          marginTop: 20,
          marginBottom: 20,
          padding: "14px 16px",
          background: "#fafafa",
          border: "1px solid #f0f0f0",
          borderRadius: 14,
        }}
      >
        <Col flex="0 0 180px">
          <Input
            prefix={<SearchOutlined style={{ color: "#bbb" }} />}
            placeholder="Immatriculation, marque..."
            allowClear
            onChange={handleSearchTexteCamion}
            style={{ width: "100%", borderRadius: 10 }}
          />
        </Col>
        <Col flex="0 1 220px">
          <ListeStatut
            liste={listeStatutCamion}
            onchange={(value) => {
              setsearchStatut(value);
              handleSearchStatutCamion(value);
            }}
            valeur={searchStatut}
          />
        </Col>
        <Col flex="0 0 auto">
          <Button
            loading={isLoading}
            icon={<ReloadOutlined />}
            onClick={handleReload}
            style={{ borderRadius: 10 }}
          >
            Actualiser
          </Button>
        </Col>
        {parseInt(localStorage.getItem("fonction_id")) === 1 && hasPermission(getPermissionsFromToken(), "CAMION_ADD") && (
          <Col flex="0 0 auto">
            <Button type="primary" icon={<PlusOutlined />} onClick={showModal} style={{ borderRadius: 10 }}>
              Ajouter
            </Button>
          </Col>
        )}
        {hasPermission(getPermissionsFromToken(), "CAMION_EXPORT") && (
          <Col flex="0 0 auto">
            <Button
              icon={<FileExcelOutlined style={{ color: "#16a34a" }} />}
              onClick={() => setisExportAllModal(true)}
              style={{ borderRadius: 10 }}
            >
              Exporter performance
            </Button>
          </Col>
        )}
        <Col flex="0 0 auto" style={{ marginLeft: "auto" }}>
          <Button
            type={isCardView ? "default" : "primary"}
            icon={isCardView ? <TableOutlined /> : <AppstoreOutlined />}
            onClick={() => setIsCardView(!isCardView)}
            style={{ borderRadius: 10 }}
          >
            {isCardView ? "Vue Tableau" : "Vue Carte"}
          </Button>
        </Col>
      </Row>

      <div className="fleet-scroll" style={{ height: "62vh", overflowY: "auto" }}>
        {isCardView ? (
          <Row gutter={[0, 0]}>
            {filteredCamions &&
              filteredCamions.map((item) => {
                const statutColor = getStatutColor(item.statut_id);
                const appartenanceColor = APPARTENANCE_COLORS[item.appartenance_id] || "#d97706";
                const chauffeur = chauffeurListe.find((c) => c.id === item.chauffeur_id);
                const site = listeSite.find((s) => s.id === item.site_id);
                const statut = listeStatutCamion.find((s) => s.id === item.statut_id);
                const carburantPct = getCarburantPercent(item);
                const carburantColor = getCarburantColor(carburantPct);
                const alertes = getAlertesCamion(item);
                const image_url = config.REACT_APP_ENDPOINT_ + item["images"];

                return (
                  <Col span={6} key={item.id} style={{ padding: 12 }}>
                    <Card
                      hoverable
                      className="fleet-card"
                      variant="borderless"
                      style={{
                        border: "1px solid #eef0f3",
                        borderRadius: 16,
                        overflow: "hidden",
                      }}
                      styles={{ body: { padding: 16 } }}
                      cover={
                        <div style={{ position: "relative" }}>
                          <img
                            src={image_url}
                            alt="camion"
                            draggable={false}
                            style={{ width: "100%", height: 140, objectFit: "cover" }}
                          />
                          <Tag
                            color={statutColor}
                            style={{
                              position: "absolute",
                              top: 10,
                              right: 10,
                              border: "none",
                              borderRadius: 20,
                              padding: "2px 10px",
                              fontWeight: 500,
                            }}
                          >
                            {statut ? statut.nom : "-"}
                          </Tag>
                        </div>
                      }
                    >
                      {/* Immatriculation + marque + appartenance/site */}
                      <div style={{ marginBottom: 12 }}>
                        <h4 style={{ marginBottom: 2, fontSize: 16 }}>{item.imm}</h4>
                        <span style={{ color: "#9ca3af", fontSize: 12.5 }}>{item.marque}</span>
                        <div style={{ display: "flex", alignItems: "center", gap: 6, marginTop: 8 }}>
                          <Tag
                            color={appartenanceColor}
                            style={{ border: "none", borderRadius: 20, fontSize: 11 }}
                          >
                            {item.appartenance_id === 1 ? "Propre" : "Location"}
                          </Tag>
                          <EnvironmentOutlined style={{ color: "#9ca3af", fontSize: 12 }} />
                          <span style={{ fontSize: 12.5, color: "#6b7280" }}>{site ? site.nom : "-"}</span>
                        </div>
                      </div>

                      {/* Chauffeur */}
                      <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 12 }}>
                        {/* <Avatar size={28} style={{ background: "#eef2ff", color: "#4f46e5", fontSize: 12, fontWeight: 600 }}>
                          {chauffeur ? getInitiales(chauffeur.nom, chauffeur.prenom) : <UserOutlined />}
                        </Avatar> */}
                        <span style={{ fontSize: 13, color: chauffeur ? "#374151" : "#c1c7d0" }}>
                          {chauffeur ? `${chauffeur.nom} ${chauffeur.prenom}` : "Non assigné"}
                        </span>
                      </div>

                      {/* Km + Carburant */}
                      <Row gutter={12} style={{ marginBottom: 12 }}>
                        <Col span={12}>
                          <div style={{ fontSize: 11, color: "#9ca3af", marginBottom: 2 }}>
                            <DashboardOutlined /> Kilométrage
                          </div>
                          <strong style={{ fontSize: 13.5 }}>{Number(item.kilometrage || 0).toLocaleString("fr-FR")} km</strong>
                        </Col>
                        <Col span={12}>
                          <div style={{ fontSize: 11, color: "#9ca3af", marginBottom: 2 }}>
                            <ThunderboltOutlined /> Carburant
                          </div>
                          <div style={{ display: "flex", justifyContent: "space-between", fontSize: 12 }}>
                            <strong>{item.carburant} L</strong>
                            <span style={{ color: carburantColor, fontWeight: 600 }}>{carburantPct}%</span>
                          </div>
                          <div style={{ height: 5, borderRadius: 4, background: "#f1f2f4", overflow: "hidden", marginTop: 3 }}>
                            <div style={{ height: "100%", width: `${carburantPct}%`, background: carburantColor, borderRadius: 4 }} />
                          </div>
                        </Col>
                      </Row>

                      {/* Alertes : uniquement si pertinent, pas de surcharge d'info */}
                      <div style={{ minHeight: 26, marginBottom: 4 }}>
                        {alertes.length === 0 ? (
                          <Tag icon={<CheckCircleFilled />} color="success" style={{ border: "none", borderRadius: 20 }}>
                            Aucune alerte
                          </Tag>
                        ) : (
                          <Space size={4} wrap>
                            {alertes.map((a, i) => (
                              <Tooltip key={i} title={`${a.type} — ${a.label}`}>
                                <Tag
                                  icon={<ExclamationCircleFilled />}
                                  color={a.level === "expired" ? "error" : "warning"}
                                  style={{ border: "none", borderRadius: 20, fontSize: 11 }}
                                >
                                  {a.type}
                                </Tag>
                              </Tooltip>
                            ))}
                          </Space>
                        )}
                      </div>

                      <Divider style={{ margin: "10px 0" }} />

                      {/* Actions */}
                      {parseInt(localStorage.getItem("fonction_id")) === 1 && (
                        <div style={{ display: "flex", justifyContent: "center", gap: 10 }}>
                          {hasPermission(getPermissionsFromToken(), "CAMION_EDIT") && (
                            <Tooltip title="Éditer le camion">
                              <Button
                                type="text"
                                icon={<EditFilled style={{ fontSize: 17, color: "#faad14" }} />}
                                onClick={() => handleEditCamion(item)}
                              />
                            </Tooltip>
                          )}
                          {hasPermission(getPermissionsFromToken(), "CAMION_DELETE") && (
                            <Tooltip title="Supprimer le camion">
                              <Button
                                type="text"
                                danger
                                icon={<DeleteOutlined style={{ fontSize: 17 }} />}
                                onClick={() => handleDelete(item)}
                              />
                            </Tooltip>
                          )}
                          {hasPermission(getPermissionsFromToken(), "CAMION_EXPORT") && (
                            <Tooltip title="Exporter les données">
                              <Button
                                type="text"
                                icon={<ExportOutlined style={{ fontSize: 17, color: "#1677ff" }} />}
                                onClick={() => {
                                  setselectedCamion(item);
                                  setisExportModal(true);
                                }}
                              />
                            </Tooltip>
                          )}
                          {hasPermission(getPermissionsFromToken(), "CAMION_CALIBRAGE") && (
                            <Tooltip title="Calibrage du camion">
                              <Button
                                type="text"
                                icon={<ShrinkOutlined style={{ fontSize: 17, color: "#6c757d" }} />}
                                onClick={() => {
                                  setselectedCamion(item);
                                  setshowModalCallibrage(true);
                                }}
                              />
                            </Tooltip>
                          )}
                          {hasPermission(getPermissionsFromToken(), "CAMION_CONSOMMATION") && (
                            <Tooltip title="Consommation carburant">
                              <Button
                                type="text"
                                icon={<LineChartOutlined style={{ fontSize: 17, color: "#16a34a" }} />}
                                onClick={() => {
                                  setselectedCamion(item);
                                  setisConsommationModalOpen(true);
                                }}
                              />
                            </Tooltip>
                          )}
                        </div>
                      )}
                    </Card>
                  </Col>
                );
              })}
          </Row>
        ) : (
          <Table
            dataSource={filteredCamions}
            columns={columns}
            rowKey="id"
            scroll={{ x: 1100 }}
            pagination={{
              pageSize: 8,
              position: ["bottomCenter"],
              className: "custom-pagination",
              style: {
                display: "flex",
                justifyContent: "center",
                marginTop: 12,
              },
              itemRender: (page, type, originalElement) => {
                if (type === "page") {
                  return (
                    <div
                      style={{
                        borderRadius: "50%",
                        minWidth: 32,
                        height: 32,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        border: "1px solid #d9d9d9",
                      }}
                    >
                      {page}
                    </div>
                  );
                }
                return originalElement;
              },
            }}
          />
        )}
      </div>

      <Modal
        // title="Supprimer ce camion"
        open={isModalDisableOpen}
        onOk={handleOkDisable}
        onCancel={() => {
          setisModalDisableOpen(false);
        }}
        okText="Supprimer"
        cancelText="Annuler"
        width={800} // largeur plus grande pour bien aligner
        style={{ top: 10 }}
        confirmLoading={isLoading}
      >
        <Row>
          <h4>
            Voulez vous vraiment supprimer le camion {selectedCamion.imm} de vos
            flotte ?
          </h4>
        </Row>
      </Modal>

      <Modal
        title="Export"
        open={isExportModal}
        onCancel={() => setisExportModal(false)}
        footer={null}
        width={800}
        style={{ top: 10 }}
      >
        <div style={{ padding: 20 }}>
          <Row gutter={[0, 20]}>
            <Col span={24}>
              <p>Sélectionnez la période :</p>
              <RangePicker
                showTime
                onChange={(values) =>
                  setexportdata({ ...exportdata, dates: values })
                }
                style={{ width: "100%" }}
                format="YYYY-MM-DD HH:mm:ss"
              />
            </Col>

            <Col span={24}>
              <p>Choisissez le type d'export :</p>
              <Radio.Group
                onChange={(e) =>
                  setexportdata({ ...exportdata, type: e.target.value })
                }
                value={exportdata.type}
                style={{ width: "100%" }}
              >
                <Row>
                  <Col span={12}>
                    <Radio value="entretien">
                      <span style={{ fontSize: 15 }}>Export Entretien</span>
                    </Radio>
                  </Col>
                  <Col span={12}>
                    <Radio value="trajet">
                      <span style={{ fontSize: 15 }}>Export Trajet</span>
                    </Radio>
                  </Col>
                </Row>
              </Radio.Group>
            </Col>

            <Col span={24} style={{ textAlign: "right" }}>
              <Space>
                <Button onClick={() => setisExportModal(false)}>Annuler</Button>
                <Button
                  loading={isLoading}
                  type="primary"
                  onClick={handleExport}
                  disabled={!exportdata.dates || !exportdata.type}
                >
                  Exporter
                </Button>
              </Space>
            </Col>
          </Row>
        </div>
      </Modal>

      {/* ---- Modal : Export performance de tous les camions ---- */}
      <Modal
        title="Exporter performance tous les camions"
        open={isExportAllModal}
        onOk={handleExportAll}
        onCancel={handleCloseExportAll}
        okText="Confirmer"
        cancelText="Annuler"
        okButtonProps={{ disabled: !exportAllDates || !exportAllDates[0] || !exportAllDates[1] }}
        confirmLoading={isLoading}
        width={600}
        style={{ top: 10 }}
        destroyOnClose
      >
        <Row gutter={[12, 16]} style={{ padding: "10px 0" }}>
          <Col span={12}>
            <p style={{ marginBottom: 4 }}>
              Date de début <span style={{ color: "red" }}>*</span>
            </p>
            <DatePicker
              style={{ width: "100%" }}
              format="YYYY-MM-DD"
              placeholder="Date de début"
              value={exportAllDates ? exportAllDates[0] : null}
              onChange={(date) =>
                setexportAllDates([date, exportAllDates ? exportAllDates[1] : null])
              }
            />
          </Col>
          <Col span={12}>
            <p style={{ marginBottom: 4 }}>
              Date de fin <span style={{ color: "red" }}>*</span>
            </p>
            <DatePicker
              style={{ width: "100%" }}
              format="YYYY-MM-DD"
              placeholder="Date de fin"
              value={exportAllDates ? exportAllDates[1] : null}
              disabledDate={(current) =>
                exportAllDates && exportAllDates[0]
                  ? current && current.isBefore(moment(exportAllDates[0]).startOf("day"))
                  : false
              }
              onChange={(date) =>
                setexportAllDates([exportAllDates ? exportAllDates[0] : null, date])
              }
            />
          </Col>
        </Row>
      </Modal>

      <Modal
        title="Calibrage"
        open={showModalCallibrage}
        onCancel={() => {
          setcurrentCallibrage([{ x: 0, y: 0 }]);
          setselectedCamion({
            id: null,
            imm: "",
            imm_rem: "",
            reference: "",
            marque: "",
            fond_cuve: 0,
            carburant: 0,
            lim_vt: null,
            lim_ass: null,
            energie_id: 0,
            chauffeur_id: 0,
            type_id: 0,
            appartenance_id: 0,
            site_id: 0,
            kilometrage: 0,
            images: null,
            dernier_date_vidange: null,
            intervalle_km_vidange: null,
            dernier_km_vidange: 0,
          });
          setshowModalCallibrage(false);
        }}
        footer={null}
        width={800}
        style={{ top: 10 }}
      >
        <div style={{ padding: 5, height: "60vh", overflowY: "auto" }}>
          {currentCallibrage.map((item, index) => (
            <Row key={index} gutter={[10, 10]} align="middle">
              <Col span={10}>
                <p>Valeur X :</p>
                <InputNumber
                  size="small"
                  style={{ width: "100%" }}
                  step={0.01}
                  min={0}
                  value={item.x}
                  onChange={(value) =>
                    handleChangeCallibrage(index, "x", value)
                  }
                />
              </Col>
              <Col span={10}>
                <p>Valeur Y :</p>
                <InputNumber
                  size="small"
                  style={{ width: "100%" }}
                  step={0.01}
                  min={0}
                  value={item.y}
                  onChange={(value) =>
                    handleChangeCallibrage(index, "y", value)
                  }
                />
              </Col>
              <Col span={4} style={{ textAlign: "center" }}>
                {currentCallibrage.length > 1 && (
                  <Button
                    type="text"
                    danger
                    icon={<DeleteOutlined />}
                    onClick={() => handleRemoveRow(index)}
                  />
                )}
              </Col>
            </Row>
          ))}

          <Button
            type="dashed"
            icon={<PlusOutlined />}
            onClick={handleAddRow}
            style={{ width: "100%", marginTop: 20 }}
          >
            Ajouter une ligne
          </Button>

          <Row style={{ marginTop: 30 }}>
            <Col span={12}></Col>
            <Col span={12} style={{ textAlign: "right" }}>
              <Space>
                <Button onClick={() => setshowModalCallibrage(false)}>
                  Annuler
                </Button>
                <Button
                  loading={isLoading}
                  type="primary"
                  onClick={handleAddCalibrage}
                >
                  Enregistrer
                </Button>
              </Space>
            </Col>
          </Row>
        </div>
      </Modal>

      <Modal
        title={`Consommation carburant — ${selectedCamion?.imm || ""}`}
        open={isConsommationModalOpen}
        onCancel={() => setisConsommationModalOpen(false)}
        footer={null}
        width={"92%"}
        style={{ top: 10 }}
        bodyStyle={{ maxHeight: "82vh", overflowY: "auto", padding: 0 }}
        destroyOnClose
      >
        {selectedCamion?.id && (
          <ConsommationCarburant camionIdLocked={selectedCamion.id} />
        )}
      </Modal>

      {showToast && (
        <Notification message={notif.message} status={notif.info} />
      )}
      <Modal
        title={titleModal}
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        okText="Enregistrer"
        cancelText="Annuler"
        width={"85%"}
        style={{ top: 10 }}
        bodyStyle={{ maxHeight: "75vh", overflowY: "auto", paddingRight: 8 }}
        confirmLoading={isLoading}
      >
        <Row gutter={[12, 16]}>
          <Col span={6}>
            <p style={{ marginBottom: 4 }}>
              Immatriculation <span style={{ color: "red" }}>*</span>
            </p>
            <Input
              size="medium"
              name="imm"
              value={selectedCamion?.imm || ""}
              onChange={handleChangeForm}
            />
          </Col>

          <Col span={6}>
            <p style={{ marginBottom: 4 }}>Immatriculation R</p>
            <Input
              size="medium"
              name="imm_rem"
              value={selectedCamion?.imm_rem || ""}
              onChange={handleChangeForm}
            />
          </Col>

          <Col span={6}>
            <p style={{ marginBottom: 4 }}>Reference</p>
            <Input
              size="medium"
              name="reference"
              value={selectedCamion?.reference || ""}
              onChange={handleChangeForm}
            />
          </Col>

          <Col span={6}>
            <p style={{ marginBottom: 4 }}>Marque</p>
            <Input
              size="medium"
              name="marque"
              value={selectedCamion?.marque || ""}
              onChange={handleChangeForm}
            />
          </Col>

          <Col span={6}>
            <p style={{ marginBottom: 4 }}>Carte grise</p>
            <Input
              size="medium"
              name="num_carte_grise"
              value={selectedCamion?.num_carte_grise || ""}
              onChange={handleChangeForm}
            />
          </Col>

          <Col span={6}>
            <p style={{ marginBottom: 4 }}>Patente</p>
            <Input
              size="medium"
              name="num_patente"
              value={selectedCamion?.num_patente || ""}
              onChange={handleChangeForm}
            />
          </Col>

          <Col span={6}>
            <p style={{ marginBottom: 4 }}>Fond de cuve</p>
            <Input
              size="medium"
              name="fond_cuve"
              value={selectedCamion?.fond_cuve || 0}
              onChange={handleChangeForm}
            />
          </Col>

          <Col span={6}>
            <p style={{ marginBottom: 4 }}>Carburant</p>
            <Input
              size="medium"
              name="carburant"
              value={selectedCamion?.carburant || 0}
              onChange={handleChangeForm}
            />
          </Col>

          <Col span={6}>
            <p style={{ marginBottom: 4 }}>Kilometrage actuelle</p>
            <Input
              size="medium"
              name="kilometrage"
              value={selectedCamion?.kilometrage || 0}
              onChange={handleChangeForm}
            />
          </Col>

          <Col span={6}>
            <p style={{ marginBottom: 4 }}>Kilometrage vidange</p>
            <Input
              size="medium"
              name="dernier_km_vidange"
              value={selectedCamion?.dernier_km_vidange || 0}
              onChange={handleChangeForm}
            />
          </Col>

          <Col span={6}>
            <p style={{ marginBottom: 4 }}>Intervalle vidange</p>
            <Input
              size="medium"
              name="intervalle_km_vidange"
              value={selectedCamion?.intervalle_km_vidange || 0}
              onChange={handleChangeForm}
            />
          </Col>

          <Col span={6}>
            <p style={{ marginBottom: 4 }}>Date limite visite technique</p>
            <DatePicker
              style={{ width: "100%" }}
              format="YYYY-MM-DD"
              placeholder="Sélectionner une date"
              value={selectedCamion.lim_vt || null}
              onChange={(date) =>
                setselectedCamion({ ...selectedCamion, lim_vt: date })
              }
            />
          </Col>

          <Col span={6}>
            <p style={{ marginBottom: 4 }}>Date limite assurance</p>
            <DatePicker
              style={{ width: "100%" }}
              format="YYYY-MM-DD"
              placeholder="Sélectionner une date"
              value={selectedCamion.lim_ass || null}
              onChange={(date) =>
                setselectedCamion({ ...selectedCamion, lim_ass: date })
              }
            />
          </Col>

          <Col span={6}>
            <p style={{ marginBottom: 4 }}>Date dernier vidange</p>
            <DatePicker
              style={{ width: "100%" }}
              format="YYYY-MM-DD"
              placeholder="Sélectionner une date"
              value={selectedCamion.dernier_date_vidange || null}
              onChange={(date) =>
                setselectedCamion({
                  ...selectedCamion,
                  dernier_date_vidange: date,
                })
              }
            />
          </Col>

          <Col span={6}>
            <p style={{ marginBottom: 4 }}>Energie</p>
            <ListeEnergie
              valeur={selectedCamion.energie_id}
              onchange={(value) =>
                setselectedCamion({ ...selectedCamion, energie_id: value })
              }
            />
          </Col>

          <Col span={6}>
            <p style={{ marginBottom: 4 }}>Type</p>
            <ListeType
              valeur={selectedCamion.type_id}
              onchange={(value) =>
                setselectedCamion({ ...selectedCamion, type_id: value })
              }
            />
          </Col>

          <Col span={6}>
            <p style={{ marginBottom: 4 }}>Chauffeur</p>
            <ListeChauffeur
              valeur={selectedCamion.chauffeur_id}
              onchange={(value) =>
                setselectedCamion({ ...selectedCamion, chauffeur_id: value })
              }
              data={chauffeurListe}
            />
          </Col>

          <Col span={6}>
            <p style={{ marginBottom: 4 }}>Situation</p>
            <ListeAppartenance
              valeur={selectedCamion.appartenance_id}
              onchange={(value) =>
                setselectedCamion({ ...selectedCamion, appartenance_id: value })
              }
            />
          </Col>

          <Col span={6}>
            <p style={{ marginBottom: 4 }}>Site</p>
            <ListeSite
              valeur={selectedCamion.site_id}
              onchange={(value) =>
                setselectedCamion({ ...selectedCamion, site_id: value })
              }
            />
          </Col>

          <Col span={6}>
            <p style={{ marginBottom: 4 }}>Image</p>
            <input type="file" accept="image/*" onChange={handleFileChange} />
          </Col>
        </Row>
      </Modal>

    </div>
  );
};

export default Camion;